import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";

export default function Deliveries() {
  const [suppliers, setSuppliers] = useState([]);
  const [branches, setBranches] = useState([]);
  useEffect(() => {
    api.get("/suppliers").then(({ data }) => setSuppliers(data));
    api.get("/branches").then(({ data }) => setBranches(data));
  }, []);
  const supplierMap = Object.fromEntries(suppliers.map((s) => [s.id, s.name]));
  return (
    <ResourcePage
      endpoint="/deliveries"
      testidPrefix="delivery"
      eyebrow="Stakeholders"
      title="Supplier Deliveries"
      subtitle="Track delivery notes, on-time performance and goods received."
      ctaLabel="Record delivery"
      fields={[
        { name: "supplier_id", label: "Supplier", type: "select", required: true,
          options: suppliers.map((s) => ({ value: s.id, label: s.name })) },
        { name: "branch", label: "Branch", type: "select", required: true, options: branches.map((b) => b.name) },
        { name: "delivery_note", label: "Delivery note #" },
        { name: "expected_date", label: "Expected date", type: "date" },
        { name: "received_date", label: "Received date", type: "date" },
        { name: "items_description", label: "Items / Goods", type: "textarea" },
        { name: "total_value", label: "Total value (UGX)", type: "number" },
        { name: "status", label: "Status", type: "select", default: "pending",
          options: ["pending", "received", "rejected"] },
      ]}
      columns={[
        { key: "delivery_note", label: "Note #" },
        { key: "supplier_id", label: "Supplier", render: (i) => supplierMap[i.supplier_id] || "—" },
        { key: "branch", label: "Branch" },
        { key: "expected_date", label: "Expected" },
        { key: "received_date", label: "Received" },
        { key: "total_value", label: "Value", render: (i) => i.total_value ? `UGX ${Number(i.total_value).toLocaleString()}` : "—" },
        { key: "status", label: "Status", render: (i) => <Badge tone={i.status === "received" ? "emerald" : i.status === "rejected" ? "red" : "amber"}>{i.status}</Badge> },
      ]}
      searchKeys={["delivery_note", "items_description"]}
    />
  );
}
